export const DATABASE_NAME = 'LOCATIONS';
export const DATABASE_VERSION = 1;
export const STORE_NAME = 'locations'
